<template>
    <v-container fluid>
        <wow-card
            :title="`WOW Kit BOM Configuration`"
            :btnText="`Create New Configuration`"
            :icon="`mdi-plus`"
            :screenType="`bomConfigurationScreen`"
            :WOWKIT_MAKER = 'WOWKIT_MAKER'
            @click="openNewConfigurationDialog"
        >
          <wow-filter
          :modelArray = 'modelListArray'
          @setBomConfigurationList = 'setBomConfigurationList'
          :configurationDialog = 'configurationDialog'
          :viewDetailsDialog = 'viewDetailsDialog'
          :C1_APPROVED = 'C1_APPROVED'
          :C2_APPROVED = 'C2_APPROVED'
          :C3_APPROVED = 'C3_APPROVED'
          />
          <WowConfigureTable
            :configurationList="configurationList"
            @openViewDetailsDialog = 'openViewDetailsDialog'
            :C1_APPROVED = 'C1_APPROVED'
            :C2_APPROVED = 'C2_APPROVED'
            :C3_APPROVED = 'C3_APPROVED'
          />
          <WowDialog
              :fullscreen="true"
              :title="`Create New Configuration`"
              v-model="configurationDialog"
              :persistent="true"
              @close="closeNewConfigurationDialog"
          >
            <new-configuration
              v-if="configurationDialog"
              :modelArray="modelListArray"
              @close="closeNewConfigurationDialog"
            />
          </WowDialog>
          <WowDialog
              :fullscreen="true"
              :title="`View Details`"
              v-model="viewDetailsDialog"
              :persistent="true"
              @close="closeViewDetailsDialog"
          >
            <WowViewDetails
              v-if="viewDetailsDialog"
              :wowKitSetModalMapObj = 'wowKitSetModalMapObj'
              :viewDetailsDialog="viewDetailsDialog"
              :C1_APPROVED = 'C1_APPROVED'
              :C2_APPROVED = 'C2_APPROVED'
              :C3_APPROVED = 'C3_APPROVED'
              @close="closeViewDetailsDialog"
            ></WowViewDetails>
          </WowDialog>
        </wow-card>
    </v-container>
</template>
<script>
import Utils from '@/utils'
import CONSTANTS from '@/utils/constants'
import Stores from '@/stores'
import WowCard from '@/components/Orders/WowKitOrdering/kitComponents/vCard'
import WowViewDetails from '@/components/Orders/WowKitOrdering/kitComponents/viewDetails'
import WowFilter from '@/components/Orders/WowKitOrdering/kitComponents/filter/filterComponent'
import WowConfigureTable from '@/components/Orders/WowKitOrdering/kitComponents/table/configurationTable'
import WowDialog from '@/components/Orders/WowKitOrdering/kitComponents/dialog/dialogComponent'
import NewConfiguration from '@/components/Orders/WowKitOrdering/kitComponents/newConfiguration'
export default {
  name: 'WowKitBomConfiguration',
  components: {
    WowCard,
    WowViewDetails,
    WowFilter,
    WowConfigureTable,
    WowDialog,
    NewConfiguration
  },
  data () {
    return {
      configurationDialog: false,
      viewDetailsDialog: false,
      modelListArray: [],
      configurationList: [],
      wowKitSetModalMapObj: null,
      C1_APPROVED: false,
      C2_APPROVED: false,
      C3_APPROVED: false,
      WOWKIT_MAKER: this.checkModuleAccess('WOW_KIT_MAKER')
    }
  },
  async created () {
    if (Stores.user.roles) {
      let getRolesArray = Stores.user.roles
      getRolesArray.forEach(item => {
        if (item.role === CONSTANTS.WOW_KIT_APPROVER_ROLE.c1Approve) {
          this.C1_APPROVED = true
        } else if (item.role === CONSTANTS.WOW_KIT_APPROVER_ROLE.c2Approve) {
          this.C2_APPROVED = true
        } else if (item.role === CONSTANTS.WOW_KIT_APPROVER_ROLE.c3Approve) {
          this.C3_APPROVED = true
        }
      })
    }
    await this.getFranchiseeModel()
  },
  methods: {
    getFranchiseeModel: async function () {
      try {
        const { data } = await http.get(`${CONSTANTS.API_URL}/api/franchisee/models`)
        this.modelListArray = data
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.$dialog.error({
          text: errorMessage,
          title: 'Error'
        })
      }
    },
    openNewConfigurationDialog: function () {
      this.configurationDialog = true
    },
    closeNewConfigurationDialog: function () {
      this.configurationDialog = false
    },
    setBomConfigurationList: function (listArray) {
      this.configurationList = listArray
    },
    openViewDetailsDialog: function (wowKitSetModalMapObj) {
      this.wowKitSetModalMapObj = wowKitSetModalMapObj
      this.viewDetailsDialog = true
    },
    closeViewDetailsDialog: function () {
      this.viewDetailsDialog = false
    },
    checkModuleAccess: function (moduleName) {
      return Utils.helper.checkAccessByModule(this.$route, moduleName)
    }
  }
}
</script>
